module.exports = __webpack_public_path__ + "img/aParty_042724_C.7b7f76b9.jpg";